import { useTranslation } from "react-i18next";

const TABLE_ROWS = [
  { category: "Hesab", features: [
    { label: "Email ünvanı sayı", s: "1", b: "10", k: "Limitsiz" },
    { label: "Yaddaş həcmi", s: "5 GB", b: "50 GB", k: "Limitsiz" },
    { label: "Əlavə ünvan əlavəsi", s: "—", b: "₼2/ünvan", k: "Daxil" },
  ]},
  { category: "Təhlükəsizlik", features: [
    { label: "FİN doğrulaması", s: true, b: true, k: true },
    { label: "SSL şifrələmə", s: true, b: true, k: true },
    { label: "End-to-End şifrələmə", s: false, b: true, k: true },
    { label: "İki faktorlu doğrulama (2FA)", s: false, b: true, k: true },
    { label: "IP qara siyahısı", s: false, b: false, k: true },
  ]},
  { category: "Filtrlər", features: [
    { label: "Spam filtri", s: true, b: true, k: true },
    { label: "Antivirus filtri", s: false, b: true, k: true },
    { label: "Xüsusi filtr qaydaları", s: false, b: false, k: true },
  ]},
  { category: "İdarəetmə", features: [
    { label: "Çoxlu istifadəçi paneli", s: false, b: false, k: true },
    { label: "Rol idarəetməsi", s: false, b: false, k: true },
    { label: "API çıxışı", s: false, b: false, k: true },
    { label: "Audit jurnalı", s: false, b: false, k: true },
  ]},
  { category: "Dəstək", features: [
    { label: "Email dəstəyi", s: true, b: true, k: true },
    { label: "Prioritet dəstək", s: false, b: true, k: true },
    { label: "24/7 dəstək + SLA", s: false, b: false, k: true },
    { label: "Şəxsi mühasib", s: false, b: false, k: true },
  ]},
];

function Cell({ val }: { val: string | boolean }) {
  if (val === true) return <i className="ri-checkbox-circle-fill text-green-500 text-lg" />;
  if (val === false) return <i className="ri-close-circle-line text-gray-300 text-lg" />;
  return <span className="text-sm font-medium text-gray-700">{val as string}</span>;
}

export default function FeatureTable() {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-stone-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="text-red-600 text-xs font-bold tracking-widest uppercase">Müqayisə</span>
          <h2 className="text-3xl font-extrabold text-gray-900 mt-2">{t("pricing.feature_table_title")}</h2>
          <p className="text-gray-500 text-sm mt-2">{t("pricing.feature_table_subtitle")}</p>
        </div>

        <div className="bg-white rounded-2xl overflow-hidden border border-gray-100">
          {/* Header */}
          <div className="grid grid-cols-4 bg-gray-50 border-b border-gray-100">
            <div className="p-5 text-xs font-bold text-gray-400 uppercase tracking-wider">Xüsusiyyət</div>
            {[
              { name: t("pricing.plan1_name"), color: "text-gray-700" },
              { name: t("pricing.plan2_name"), color: "text-red-600" },
              { name: t("pricing.plan3_name"), color: "text-gray-900" },
            ].map((p) => (
              <div key={p.name} className="p-5 text-center">
                <span className={`text-sm font-bold ${p.color}`}>{p.name}</span>
              </div>
            ))}
          </div>

          {/* Rows */}
          {TABLE_ROWS.map((group) => (
            <div key={group.category}>
              {/* Category row */}
              <div className="bg-stone-50 px-5 py-2.5 border-y border-gray-100">
                <span className="text-xs font-bold text-gray-400 uppercase tracking-wider">{group.category}</span>
              </div>
              {group.features.map((row, idx) => (
                <div
                  key={row.label}
                  className={`grid grid-cols-4 items-center border-b border-gray-50 hover:bg-stone-50/50 transition-colors ${idx % 2 === 0 ? "" : "bg-white"}`}
                >
                  <div className="p-4 pl-5 text-sm text-gray-600">{row.label}</div>
                  {[row.s, row.b, row.k].map((val, i) => (
                    <div key={i} className="p-4 flex items-center justify-center">
                      <Cell val={val} />
                    </div>
                  ))}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
